import React, {useState, useEffect} from 'react'
import './Performancecard.css'
import Permormance from './Permormance'
import {IoDownloadOutline} from 'react-icons/io5'

const Performancecard = () => {
  useEffect(() => {
    handleWidth()
  }, [])

  const [widthval, setWidthval] = useState({
    bar1: '0%',
    bar2: '0%',
    bar3: '0%',
    bar4: '0%'
  })

  const handleWidth = () =>{
    setWidthval({bar1: '65%', bar2: '85%', bar3: '45%', bar4: '30%'})
  }

  return (
    <div className='Performancecard-container'>
        <div className='Performancecard-top'>
            <span>Performance Statistics</span>
            <span><IoDownloadOutline id='perf-icon'/></span>
        </div>
        <div className='Performancecard-bottm'>
            <Permormance teamname='Technical Team' bcolor='#00C2FF' bwidth={widthval.bar1}/>
            <Permormance teamname='Sales Team' bcolor='#FF5C00' bwidth={widthval.bar2}/>
            <Permormance teamname='Marketing Team' bcolor='#00FF75' bwidth={widthval.bar3}/>
            <Permormance teamname='Management Team' bcolor='#FF66E7' bwidth={widthval.bar4}/>
        </div>
    </div>
  )
}

export default Performancecard